<template>
  <span ref="container" class="dropdown mr-2">
    <button
      class="btn btn-light btn-sm dropdown-toggle"
      type="button"
      @click="show = !show"
    ></button>
    <div class="dropdown-menu mt-2 shadow" :class="{ show }">
      <span class="dropdown-header">Filter by Role</span>
      <div
        v-for="role in allowedRoles"
        :key="role"
        class="dropdown-item pl-2"
        href="#"
        @click="toggleRole(role)"
      >
        <input type="checkbox" :name="role" :checked="value.includes(role)" />
        <span class="ml-2">{{ role }}</span>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: { required: true, type: Array },
    allowedRoles: { required: true, type: Array },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    toggleRole(role) {
      let roles
      if (this.value.includes(role)) {
        roles = this.value.filter((r) => r != role)
      } else {
        roles = [...this.value, role]
      }
      this.$emit("input", roles)
    },
  },
}
</script>

<style></style>
